/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyDollarZimbabwean = createReactComponent(
  "currency-dollar-zimbabwean",
  "IconCurrencyDollarZimbabwean",
  [
    ["path", { d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", key: "svg-0" }],
    ["path", { d: "M17 20v-2", key: "svg-1" }],
    ["path", { d: "M18 6v-2", key: "svg-2" }],
    ["path", { d: "M3 6h7l-7 12h7", key: "svg-3" }]
  ]
);

export { IconCurrencyDollarZimbabwean as default };
//# sourceMappingURL=IconCurrencyDollarZimbabwean.js.map
